// The shapes this module's API returns and accepts.

import { z } from "zod";

// Auto-delete windows, in days; 0 keeps every notification.
export const NOTIFICATION_RETENTION_DAYS_OPTIONS = [1, 3, 7, 14, 30, 90, 0] as const;

/** One notification. Named `AppNotification` so it does not shadow the
 *  browser's own `Notification`. `source` is the sender's id and `meta` what
 *  its presentation needs; neither is known to this module. */
export interface AppNotification {
  id: number;
  source: string;
  title: string;
  body: string | null;
  href: string | null;
  meta: Record<string, unknown> | null;
  readAt: string | null;
  createdAt: string;
}

export interface NotificationsListResponse {
  rows: AppNotification[];
  /** Matching the current `unreadOnly` filter, for pagination. */
  total: number;
}

export const notificationsQuerySchema = z.object({
  unreadOnly: z
    .enum(["true", "false"])
    .optional()
    .transform((v) => v === "true"),
  limit: z.coerce.number().int().min(1).max(200).default(20),
  // Offset pagination: the page's numbered pagination needs a real `total`.
  offset: z.coerce.number().int().min(0).default(0),
});

export type NotificationsQuery = z.infer<typeof notificationsQuerySchema>;

export const markNotificationReadSchema = z.object({ read: z.boolean() }).strict();

export const updateNotificationRetentionDaysSchema = z.object({
  days: z.coerce
    .number()
    .int()
    .refine(
      (n) => (NOTIFICATION_RETENTION_DAYS_OPTIONS as readonly number[]).includes(n),
      "Unsupported retention window",
    ),
});
